export default __webpack_public_path__ + "static/media/dedicated.d0b7b206.svg";